import {QueryFunctionContext} from 'react-query';

import request from '../../../axios';

export const getSupplierStories = async () => {
  const {data}: {data: IStory[]} = await request.get(
    `/api/v2/store/supplier-stories`,
  );

  return data;
};

export const getSupplierPostStories = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IPerStory[]} = await request.get(
    `/api/v2/store/story-posts?story_guid=${ctx.queryKey[1]}`,
  );
  return data;
};
